import { render, staticRenderFns } from "./DataBlock.vue?vue&type=template&id=436b6114&"
import script from "./DataBlock.vue?vue&type=script&lang=js&"
export * from "./DataBlock.vue?vue&type=script&lang=js&"
import style0 from "./DataBlock.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports